import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab1 = ({
  IdData,
  SupplierName,
  SupplierGroup,
  SupplierType,
  Territory,
  IsTransporter,
  BillingCurrency,
  DefaultCompanyBankAccount,
  DefaultPriceList,
  IsInternalSupplier,
  RepresentsCompany,
  Website,
  SupplierDetails,
}) => {
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Input
              id="SupplierName"
              style={{
                height: "30px",
                border: SupplierName.Error ? "1px solid red" : "",
              }}
              label="Supplier Name"
              value={SupplierName.SupplierName}
              readOnly
              onChange={(e) => SupplierName.setSupplierName(e.target.value)}
            />
          </div>
        </div>

        <div className="col-3 ">
          <div className={SupplierGroup.Error ? `mb-3 errorborder` : `mb-3`}>
            <Input label="Supplier Group" readOnly value={SupplierGroup.select_SupplierGroup} style={{ height: "30px" }} />


          </div>
        </div>
        <div className="col-3 ">
          <div className={SupplierType.Error ? `mb-3 errorborder` : `mb-3`}>
            <Input label="Supplier Type" readOnly value={SupplierType.SupplierType} style={{ height: "30px" }} />



          </div>
        </div>
        <div className="col-3 ">
          <div className={Territory.Error ? `mb-3 errorborder` : `mb-3`}>
            <Input label="Territory" readOnly value={Territory.select_Territory} style={{ height: "30px" }} />



          </div>
        </div>
        <div className="col-4 ">
          <div className="mb-3">
            <Checkbox
              id="IsTransporter"
              label="Is Transporter"
              value={IsTransporter?.IsTransporter || false}
              onChange={(val) => IsTransporter?.setIsTransporter?.(val)}
              disabled={true}
            />
          </div>
        </div>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Defaults</p>
        </div>

        <div className="col-4">
          <div className={BillingCurrency.Error ? `mb-3 errorborder` : `mb-3`}>
            <Input label="Billing Currency" readOnly value={BillingCurrency.select_BillingCurrency} style={{ height: "30px" }} />


          </div>
        </div>

        <div className="col-4">
          <div
            className={
              DefaultCompanyBankAccount.Error ? `mb-3 errorborder` : `mb-3`
            }
          >
            <Input label="Default Company Bank Account" readOnly value={DefaultCompanyBankAccount.select_DefaultCompanyBankAccount} style={{ height: "30px" }} />


          </div>
        </div>
        <div className="col-4">
          <div className={DefaultPriceList.Error ? `mb-3 errorborder` : `mb-3`}>
            <Input label="Default Price List" readOnly value={DefaultPriceList.select_DefaultPriceList} style={{ height: "30px" }} />


          </div>
        </div>

        <div className="col-4 ">
          <div className="mb-3">
            <Checkbox
              id="IsInternalSupplier"
              label="Is Internal Supplier"
              value={IsInternalSupplier?.IsInternalSupplier || false}
              // onChange={(val) =>
              //   IsInternalSupplier?.setIsInternalSupplier?.(val)
              // }
              disabled={true}
              onChange={(val) => {
                IsInternalSupplier?.setIsInternalSupplier?.(val);

                // Clear select value when unchecked
                if (!val) {
                  RepresentsCompany?.setselect_RepresentsCompany?.(''); // or ''
                }
              }}
            />
          </div>
        </div>

        {IsInternalSupplier?.IsInternalSupplier !== 0 && (
          <>
            <div className="col-4">
              <div className="mb-3">
                <Input label="Represents Company" readOnly value={RepresentsCompany.select_RepresentsCompany} style={{ height: "30px" }} />


              </div>
            </div>

          </>
        )}
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">More Information</p>
        </div>
        <div className="col-6">
          <div className="mb-3">
            <Input
              id="Website"
              style={{
                height: "30px",
                border: Website.Error ? "1px solid red" : "",
              }}
              readOnly
              label="Website"
              value={Website.Website}
              onChange={(e) => Website.setWebsite(e.target.value)}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-3">
            <Textarea
              style={{
                height: "150px",
                border: SupplierDetails?.Error ? "1px solid red" : "",
              }}
              readOnly
              label="Supplier Details"
              value={SupplierDetails.SupplierDetails}
              onChange={(e) =>
                SupplierDetails.setSupplierDetails(e.target.value)
              }
            />
            <p
              style={{
                paddingLeft: "14px",
                paddingRight: "14px",
                fontWeight: 400,
                fontSize: "9px",
                letterSpacing: "0",
                lineHeight: '2',
                color: "#00000099",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              Statutory info and other general information about your Supplier
            </p>
          </div>
        </div>


      </div>
      <div className="">
        <ActivityCard doctype="Supplier" docname={IdData} />
      </div>

    </>
  );
};

export default Tab1;
